import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=10c85196&scoped=true&"
import script from "./UpdateModal.vue?vue&type=script&lang=js&"
export * from "./UpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateModal.vue?vue&type=style&index=0&id=10c85196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c85196",
  null
  
)

export default component.exports